import { ActionButtonProps, Box, BoxProps, Form, Icon, Loader, Spacer } from '@jfs/ui-new'
import { Button } from '../../components/AdminButton'
import { FC, useEffect, useRef, useState } from 'react'
import { CloseForm } from '../../components/CloseForm'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { getIdFromMap, MessageTypes } from '../../utils'
import { FORM_MESSAGE } from '../../utils/constants'
import { formData } from './formData'

interface GenerateFileFormProps {
  data: any
  onUpdate: () => void
  isDeletable: boolean
  onClose: () => void
}

const GenerateFileForm: FC<GenerateFileFormProps> = (props: GenerateFileFormProps) => {
  const { data, onUpdate, isDeletable, onClose } = props
  const { id } = data

  console.log({ data })

  const [toggle, setToggle] = useState({ isToggle: false, type: '', message: '' })
  const [isLoading, setLoading] = useState(false)
  const [isDeleteLoading, setDeleteLoading] = useState(false)
  const valuesRef = useRef<any>({})

  const {
    fetchFileNames,
    fileNames,
    rules,
    add,
    update,
    checkUpdate,
    deleteFile,
    checkDelete,
    setMessage,
    initialRules,
    message,
  } = useStores((store) => ({
    fetchFileNames: store.generateExcelFile.fetchFileNames,
    add: store.generateExcelFile.add,
    update: store.generateExcelFile.update,
    checkUpdate: store.generateExcelFile.checkUpdate,
    deleteFile: store.generateExcelFile.deleteFile,
    checkDelete: store.generateExcelFile.checkDelete,

    fileNames: store.generateExcelFile.getInstrumentFileNames(),
    length: store.generateExcelFile.instrumentFilenames.length,
    rules: store.routingRule.getRulesForFile(),
    rulesLength: store.routingRule.rules.length,
    setMessage: store.message.setMessage,
    initialRules: store.routingRule.getRulesForInitialValues(data),
    message: store.message.getFormMessage(),
  }))

  const [lazyAdd, lazyAddHandler] = useLazyApiData(add)
  const [lazyUpdate, lazyUpdateHandler] = useLazyApiData(update)
  const [lazyDelete, lazyDeleteHandler] = useLazyApiData(deleteFile)

  useEffect(() => {
    fetchFileNames()
  }, [fetchFileNames])

  useEffect(() => {
    if (lazyAddHandler.state === 'fulfilled') {
      onUpdate()
    }
    if (lazyAddHandler.state === 'rejected') {
      // onUpdate()
    }
  }, [lazyAddHandler, onUpdate])

  useEffect(() => {
    if (lazyUpdateHandler.state === 'fulfilled') {
      onUpdate()
    }
  }, [lazyUpdateHandler, onUpdate])

  useEffect(() => {
    if (lazyDeleteHandler.state === 'fulfilled') {
      onUpdate()
    }
  }, [lazyDeleteHandler, onUpdate])

  const getRuleIds = (values: any) => {
    const rulesId = values.split(',').map((item: string) => item.split('-')[0])
    console.log({ values })
    const t = rulesId.join(',') ?? ''
    console.log({ t })
    return t
  }

  const getRules = (values: any) => {
    const strRules = values?.rules.split(',')
    const rules = strRules && strRules?.map((item: any) => getIdFromMap(item))
    return rules?.join(',')
  }

  const onAdd = (values: any) => {
    console.log({ values })
    lazyAdd({
      ...values,
      rules: getRuleIds(values.rules),
    })
  }

  const updateRule = () => {
    lazyUpdate({
      id,
      ...valuesRef.current,
      rules: getRules(valuesRef.current),
    })
  }

  const deleteRule = () => {
    lazyDelete({
      id,
      ...valuesRef.current,
      rules: getRules(valuesRef.current),
    })
  }

  const onFailed = (message: string) => {
    setMessage(message, MessageTypes.ERROR, FORM_MESSAGE)
    // onUpdate()
  }

  const alertWarning = (alerttype: string, message: string) => {
    setToggle({ isToggle: true, type: alerttype, message: message })
  }

  const checkEligible = (response: any, alerttype: string) => {
    switch (response?.status) {
      case 'SUCCESS':
        alerttype === 'UPDATE' ? updateRule() : alertWarning(alerttype, response?.message) // deleteRule()
        break
      case 'WARNING':
        alertWarning(alerttype, response?.message)
        break
      case 'FAILED':
        onFailed(response?.message)
        break
    }
  }

  const onCheckUpdate = async (values: any) => {
    setLoading(true)
    const response = await checkUpdate({
      id,
      ...values,
      rules: getRules(values),
    })
    console.log({ response })
    setLoading(false)
    checkEligible(response, 'UPDATE')
  }

  const onCheckDelete = async () => {
    setDeleteLoading(true)
    const response = await checkDelete({
      id,
      ...valuesRef.current,
      rules: getRules(valuesRef.current),
    })
    setDeleteLoading(false)
    checkEligible(response, 'DELETE')
  }

  const onWarningConfirm = () => {
    if (toggle.type === 'UPDATE') {
      updateRule()
    }
    if (toggle.type === 'DELETE') {
      deleteRule()
    }
  }

  const onDismiss = () => {
    setToggle({ isToggle: false, type: '', message: '' })
  }

  const handleActions = ({ values, title, defaultActionButtonOnSubmit }: ActionButtonProps) => {
    valuesRef.current = values
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box paddingBottom={16} flexDirection="row">
        <ModalAlertView
          onPress={onWarningConfirm}
          show={toggle.isToggle}
          onDismiss={onDismiss}
          title="Alert!"
          buttonTitle="Yes"
          message={toggle.message}
          onCancel={onDismiss}
          cancelTitle="No"
        />
        <Button
          title={id ? 'Update' : title}
          onPress={handleOnPress}
          isLoading={isLoading || lazyUpdateHandler.state === 'pending' || lazyAddHandler.state === 'pending'}
        />
        <Spacer direction="horizontal" size={16} />
        {isDeletable && id && (
          <Box
            onPress={!isDeleteLoading ? onCheckDelete : undefined}
            bg="RED"
            underlayColor="ERROR"
            p={'MEDIUM'}
            justify={'center'}
            align={'center'}
            borderRadius={4}>
            {!isDeleteLoading && <Icon id="DELETE" size={24} color="WHITE" />}
            {isDeleteLoading && <Loader type="small" color="WHITE" />}
          </Box>
        )}
      </Box>
    )
  }

  return (
    <Box {...styles.formContainer}>
      <CloseForm onClose={onClose} />
      <Form
        formData={formData(id, fileNames, rules, onAdd, onCheckUpdate, message)}
        actionButtons={handleActions}
        initialValues={id ? initialRules : {}}
      />
    </Box>
  )
}

export { GenerateFileForm }

const styles = {
  formContainer: {
    underlayColor: 'WHITE',
    height: '100vh',
    overflow: 'auto',
    bg: 'WHITE',
    padding: 'MEDIUM',
  } as BoxProps,
}
